import { useMemo } from 'react';
export const useLiveStreamActiveWhitelist = () => {
    return useMemo(() => typeof window !== 'undefined' &&
        [
            /business\.fireworktv\.com/,
            /business\.firework\.com/,
            /business\.firework\.tv/,
            /mandalore-([a-zA-Z0-9-]+)-firework\.vercel\.app/,
            /localhost/,
        ]
            .map((regexp) => regexp.test(window.location.host))
            .filter(Boolean).length > 0, []);
};
